<template>
    <div id="option"
        @click="$emit('update', times)"
        class="ui inverted button">
        <span v-if="!is_date">
            {{ $t(option.i18n_key) }}
        </span>
        <span v-else>
            {{ $t(option.date_i18n_key) }}
        </span>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        is_date: Boolean,
        option: {
            type: Object,
            default: () => { return {} }
        },
    },
    data () {
        return {
            times: []
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            this.times = this.option.get_times()
        },
    },
}
</script>

<style lang="scss" scoped>
    #option {
        cursor: pointer;
        margin: 6px;
    }
</style>
